{
  "$schema": "https://mux.run/theme.json",
  "name": "Gruvbox",
  "id": "gruvbox",
  "light": {
    "palette": {
      "neutral": "#fbf1c7",
      "ink": "#3c3836",
      "primary": "#076678",
      "accent": "#9d0006",
      "success": "#79740e",
      "warning": "#b57614",
      "error": "#9d0006",
      "info": "#8f3f71",
      "diffAdd": "#79740e",
      "diffDelete": "#9d0006"
    },
    "overrides": {
      "syntax-comment": "#928374",
      "syntax-keyword": "#9d0006",
      "syntax-primitive": "#076678",
      "syntax-constant": "#8f3f71"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#282828",
      "ink": "#ebdbb2",
      "primary": "#83a598",
      "accent": "#fb4934",
      "success": "#b8bb26",
      "warning": "#fabd2f",
      "error": "#fb4934",
      "info": "#d3869b",
      "diffAdd": "#b8bb26",
      "diffDelete": "#fb4934"
    },
    "overrides": {
      "syntax-comment": "#928374",
      "syntax-keyword": "#fb4934",
      "syntax-primitive": "#83a598",
      "syntax-constant": "#d3869b"
    }
  }
}
